export const NEXT = "next";
export const RESULTS_SUM = "results sum";
